import { httpClient } from '../httpClient';
export class BundleOptionRepository {
    // レ点オプション取得
    async getBundleOption(params) {
        const { data } = await httpClient.get(`bundleOption/${params.mstServiceId}/fetch`);
        return data;
    }
    // (レ点オプション申し込み画面用)レ点オプション取得
    async getBundleOptionDisplay(params) {
        const { data } = await httpClient.get(`bundleOption/display/${params.mstServiceId}`);
        return data;
    }
    // (契約情報画面用)レ点オプション一覧取得
    async getBundleOptionDisplayList() {
        const { data } = await httpClient.get(`bundleOption/display/list`);
        return data;
    }
    // レ点オプション解約
    async terminateBundleOption(params) {
        const { data, status } = await httpClient.post(`bundleOption/${params.bundleOptionId}/terminate/individual`, JSON.stringify(({ serviceCode: params.serviceCode, terminateType: params.terminateType } = params)));
        if (status !== 201) {
            alert('エラーが発生しました。再度やり直してください。');
            throw Error();
        }
        return data;
    }
    // レ点オプション申込
    async registerBundleOptionOemls(params) {
        const { data, status } = await httpClient.post(`bundleOption/register-oemls`, JSON.stringify(({ serviceCode: params.serviceCode } = params)));
        if (status !== 201) {
            alert('エラーが発生しました。再度やり直してください。');
            throw Error();
        }
        return data;
    }
    // レ点オプション申込(MAIL_ISP)
    async registerBundleOptionFreebit(params) {
        const { data, status } = await httpClient.post(`bundleOption/register-freebit`, JSON.stringify(({ serviceCode: params.serviceCode, email: params.email, emailPassword: params.emailPassword } = params)));
        if (status !== 201) {
            alert('エラーが発生しました。再度やり直してください。');
            throw Error();
        }
        return data;
    }
    // レ点オプション申込(キングソフト)
    async registerBundleOptionKingsoft(params) {
        const { data, status } = await httpClient.post(`bundleOption/register-kingsoft`, JSON.stringify(({ serviceCode: params.serviceCode } = params)));
        if (status !== 201) {
            alert('エラーが発生しました。再度やり直してください。');
            throw Error();
        }
        return data;
    }
    // レ点オプション申込(でんわパック60)
    async registerBundleOptionDenwapack60(params) {
        const { data, status } = await httpClient.post(`bundleOption/register-denwapack60`, JSON.stringify(({ serviceCode: params.serviceCode } = params)));
        if (status !== 201) {
            alert('エラーが発生しました。再度やり直してください。');
            throw Error();
        }
        return data;
    }
    // レ点オプション申込(aloha音声オプション)
    async registerBundleOptionAloha(params) {
        const { data, status } = await httpClient.post(`bundleOption/register-voice-option`, JSON.stringify(({ serviceCode: params.serviceCode } = params)));
        if (status !== 201) {
            alert('エラーが発生しました。再度やり直してください。');
            throw Error();
        }
        return data;
    }
    // ISPメール一覧取得
    async getMailIsp() {
        const { data } = await httpClient.get(`bundleOption/mail/isp`);
        return data;
    }
    async changeMailIspPassword(params) {
        const { data, status } = await httpClient.post(`bundleOption/change-password-freebit`, JSON.stringify(({
            bundleOptionId: params.bundleOptionId,
            serviceCode: params.serviceCode,
            emailPassword: params.emailPassword
        } = params)));
        if (status !== 201) {
            alert('エラーが発生しました。再度やり直してください。');
            throw Error();
        }
        return data;
    }
}
